import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { APP_CONFIG, IAppConfig } from '@app/core/config';
import { UtilsService } from '@app/core/services';
import { ProfileInfo } from '../../profile/models';
import { DashboardRequestActive, VerificationDetail } from '../models';
import { DashboardView } from '../models/dashboard-view';
import { IDashboradNewWalletsModel } from '../models/dashboard-new-wallets.model';


@Injectable({
	providedIn: 'root'
})
export class DashboardService {

	constructor(
		@Inject(APP_CONFIG) private appConfig: IAppConfig,
		private http: HttpClient,
		private utilsService: UtilsService
	) { }

	getInfo(): Observable<DashboardView> {
		const url = `${this.appConfig.apiEndpoint}/v2/dashboard/report`;
		return this.http.get<DashboardView>(url)
			.pipe(map(this.utilsService.handleResponse));
	}

	getProfile(): Observable<ProfileInfo> {
		const url = `${this.appConfig.apiEndpoint}/v2/profile`;
		return this.http.get<ProfileInfo>(url).pipe(
			map(response => {
				const data = response['data'] || ({} as ProfileInfo);
				return data;
			})
		);
	}

	getVerficationType(): Observable<VerificationDetail> {
		return this.http.get(`${this.appConfig.apiEndpoint}/v2/dashboard/verification`)
			.pipe(map(this.utilsService.handleResponse));
	}

	getKycState(): Observable<boolean> {
		return this.http.get(`${this.appConfig.apiEndpoint}/v2/dashboard/KYCState`)
			.pipe(map((data) => {
				return data['response'];
			}));
	}

	getReqActive(): Observable<DashboardRequestActive[]> {
		const url = `${this.appConfig.apiEndpoint}/v2/Request/History/Active`;
		return this.http.get<DashboardRequestActive[]>(url)
			.pipe(map(this.utilsService.handleResponse));
	}

	getSettings(): string {
		let randomNumber = new Date().getTime();
		const url = `https://tc-static-public.topchnge.net/download/app/my.json?v=${randomNumber}`;
		var xmlHttp = new XMLHttpRequest();
		xmlHttp.open("GET", url, false);
		xmlHttp.send(null);
		return xmlHttp.responseText;
	}
}
